export default __webpack_public_path__ + "static/media/llantek.abd9f7d1.png";